const TEXT_ENCODER = new TextEncoder();

function textToArrayBuffer(text: string) {
  return TEXT_ENCODER.encode(text);
}

// https://stackoverflow.com/a/55200387
function bytesToHex(ab: ArrayBuffer) {
  const bytes = new Uint8Array(ab);
  const hexBytes = [];
  for (let i = 0; i < bytes.length; i += 1) {
    const byteString = bytes[i].toString(16).padStart(2, '0');
    hexBytes.push(byteString);
  }
  return hexBytes.join('');
}

export async function sha256(data: ArrayBuffer | string) {
  if (typeof data === 'string') {
    data = textToArrayBuffer(data);
  }
  const hash = await crypto.subtle.digest({ name: 'SHA-256' }, data);
  return bytesToHex(hash);
}

export async function hmacSha256(message: string, secret: string) {
  const algorithm = { name: 'HMAC', hash: 'SHA-256' };
  const encodedSecret = textToArrayBuffer(secret);
  const encodedMessage = textToArrayBuffer(message);
  const key = await crypto.subtle.importKey('raw', encodedSecret, algorithm, false, ['sign']);
  const signature = await crypto.subtle.sign(algorithm.name, key, encodedMessage);
  return bytesToHex(signature);
}
